import { PlatformModulesEnum, PLATFORM_PERMISSIONS, PLATFORM_RULES } from '@thinknet-gmbh/platform-common';
import { ICONS } from '@thinknet-gmbh/platform-common-ui';

import { ROUTES } from 'src/components/app/app-routes.constants';

export const SIDEBAR_CONFIG = {
  module: PlatformModulesEnum.YUU_HR_MODULE,
  menuItems: [
    { title: 'dashboard', icon: ICONS.homeAlt, path: ROUTES.dashboard },
    // { title: 'orgStructure', icon: ICONS.server, path: ROUTES.orgStructure },
    {
      title: 'ownData',
      icon: ICONS.folderMinus,
      path: ROUTES.ownData,
    },
    {
      title: 'employee',
      icon: ICONS.briefcase,
      path: ROUTES.employee,
      permission: PLATFORM_PERMISSIONS.memberManagement,
    },
    {
      title: 'jobs',
      icon: ICONS.bookContent,
      path: ROUTES.jobs,
      permission: PLATFORM_PERMISSIONS.jobManagement,
    },
    {
      title: 'vacancies',
      icon: ICONS.userPin,
      path: ROUTES.vacancies,
      permission: PLATFORM_PERMISSIONS.vacanciesManagement,
    },
    {
      title: 'taskManager',
      icon: ICONS.cubeAlt,
      path: ROUTES.taskManager,
      permission: PLATFORM_PERMISSIONS.taskManagement,
    },
    {
      title: 'payrollAccounting',
      icon: ICONS.file,
      path: ROUTES.payrollAccounting,
      permission: PLATFORM_PERMISSIONS.payrollAccounting,
      rule: PLATFORM_RULES.manageAll
    },
    {
      title: 'documentImporter',
      icon: ICONS.folderOpen,
      path: ROUTES.documentImporter,
      permission: PLATFORM_PERMISSIONS.documentImporter,
      rule: PLATFORM_RULES.manageAll
    },
    { title: 'applications', icon: ICONS.gridAlt, path: ROUTES.application },
  ],
  menuItemsPrimary: [{ title: 'settings', icon: ICONS.cog, path: ROUTES.settings }],
};
